import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import './layout.css'
import { ThemeToggle } from '../components/ThemeToggle'

/**
 * PublicPageShell — schlanker Rahmen fuer Seiten, die auch ohne Login
 * erreichbar sind.
 *
 * Anlass sind die Hotspot-Detailseiten: sie waren in v1 oeffentlich, rund
 * 100.000 davon lagen im Google-Index, und die Besucher, die ueber die Suche
 * kommen, sollen etwas Brauchbares sehen statt einer Login-Wand. Der
 * eingeloggte Fall benutzt weiterhin die AppShell mit Seitenleiste — welcher
 * Rahmen greift, entscheidet die jeweilige Route.
 *
 * Bewusst nicht die AppShell fuer beides: die zieht Konto, Berechtigungen,
 * Kontingente und Benachrichtigungen, also lauter Abfragen, die ein anonymer
 * Besucher gar nicht beantwortet bekommt.
 *
 * Nah an PublicLegalLayout (/imprint, /privacy) gehalten, inklusive derselben
 * public-header/public-main-Klassen — nur mit Anmelde-Aufforderung statt
 * Rechtstext-Reitern.
 */
export function PublicPageShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation('common')

  return (
    <div className="public-layout" data-testid="public-page-shell">
      <header className="public-header">
        <div className="public-header__inner">
          <Link to="/" className="public-header__brand">
            <div className="logo-mark">H</div>
            <span className="public-header__name">HeliumTracker</span>
          </Link>
          <nav className="public-header__nav">
            <ThemeToggle />
            <Link to="/login" className="btn">
              {t('publicShell.login', 'Anmelden')}
            </Link>
            <Link to="/register" className="btn btn-primary">
              {t('publicShell.register', 'Kostenlos registrieren')}
            </Link>
          </nav>
        </div>
      </header>

      <main className="public-main">{children}</main>
    </div>
  )
}
